import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Modal,
  TextField,
  Typography,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import BodyWapperUI from "../../common/BodyWapperUI";
import { appListAction } from "../../redux/toolkit/apps/list";
import { useDispatch, useSelector } from "react-redux";
import { userPublisherDataAction } from "../../redux/toolkit/dashboard/userPublisherData";
import { totalSurveyAttemptPublisherAction } from "../../redux/toolkit/dashboard/totalSurveyAttempt";
import { publisherPayoutAction } from "../../redux/toolkit/dashboard/publisherPayout";
import { userPayoutAction } from "../../redux/toolkit/dashboard/userPayout";
import { dailyRevenueGraphAction } from "../../redux/toolkit/dashboard/dailyRevenueGraph";
import { dailyActiveUserGraphAction } from "../../redux/toolkit/dashboard/dailyActiveUserGraph";
import { dateFormatStartFun } from "../../helper/dateConverter";

import dayjs from "dayjs";

import * as yup from "yup";
import moment from "moment/moment";
import { use } from "react";

const filter_schema = yup
  .object()
  .shape({
    // app_name: yup.string().required('App Name is required.'),
    // app_logo: yup.string().required('App logo is required.'),
    // currency_name: yup.string().required('Currency Name is required.'),
    // currency_logo: yup.string().required('Currency Logo is required.'),
  })
  .required();

const p_Properties = {
  paddingBlock: "10px",
  fontSize: "12px",
  display: "flex",
  color: "rgba(47, 52, 62, 1)",
};

const DashboardFilter = ({ onDateRangeChange }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedDate, setSelectedDate] = useState({
    start: null,
    end: null,
  });
  const [selectedApp, setSelectedApp] = useState({});
  const formRef = useRef(null);
  const { data: appData } = useSelector((state) => state.appLists);
  const dispatch = useDispatch();

  const {
    register,
    setValue,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(filter_schema) });

  const handleDashboardFilter = (data) => {
    data.app_id = selectedApp._id;
    data.s_date = selectedDate.start;
    data.e_date = selectedDate.end;
    dispatch(userPublisherDataAction(data));
    dispatch(totalSurveyAttemptPublisherAction(data));
    dispatch(publisherPayoutAction(data));
    dispatch(userPayoutAction(data));
    dispatch(dailyRevenueGraphAction(data));
    dispatch(dailyActiveUserGraphAction(data));
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    const app = appData.find((item) => item.app_name === selectedValue); // Find the full object
    setSelectedApp(app); // Set the entire object
  };

  const handleDateChange = (key, newValue) => {
    const standardizedDate = newValue
      ? dayjs(newValue).startOf("day").format("YYYY-MM-DD")
      : null;
    setSelectedDate((prev) => ({
      ...prev,
      [key]: standardizedDate,
    }));
  };

  useEffect(() => {
    dispatch(appListAction({ is_deleted: false }));
  }, [dispatch]);

  useEffect(() => {
    if (selectedApp?._id && selectedDate.start && selectedDate.end) {
      const diffTime = Math.abs(
        new Date(selectedDate.end) - new Date(selectedDate.start)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // Build a readable label
      const label = diffDays === 0 ? "1 day" : `Last ${diffDays + 1} Days Data`;

      onDateRangeChange(label);

      alert("Are you sure?");
      formRef.current?.requestSubmit(); // ✅ Triggers form submit
    }
  }, [selectedApp, selectedDate]); // Make sure to include selectedDate too

  return (
    <>
      <Card elevation={0} sx={{ width: "100%" }}>
        <form
          ref={formRef}
          sx={{ height: "auto" }}
          onSubmit={handleSubmit(handleDashboardFilter)}
        >
          <Grid
            container
            sx={{
              width: "100%",
              flexDirection: "row",
              justifyContent: {
                xs: "flex-start",
                sm: "flex-start",
                md: "flex-end",
              },
              gap: {
                xs: "0px",
                sm: "30px",
                md: "10px",
              },
            }}
          >
            <Grid container xs={10} sm={4} md={3}>
              <Typography sx={p_Properties} variant="p">
                In App Product
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  displayEmpty
                  sx={{
                    fontSize: "14px",
                    minWidth: "200px",
                  }}
                  id="select"
                  value={selectedApp?.app_name || ""}
                  onChange={handleChange}
                >
                  <MenuItem value="">
                    <em>Select an app</em>
                  </MenuItem>
                  {appData?.map((item, i) => (
                    <MenuItem key={i} value={item.app_name}>
                      {item.app_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Date Picker */}
            <Grid container xs={12} sm={3} md={3}>
              <Typography sx={p_Properties} variant="p">
                Start Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  // label="SelectStart Date"
                  value={selectedDate?.start}
                  onChange={(newValue) =>
                    setSelectedDate({
                      ...selectedDate,
                      start: dateFormatStartFun(newValue),
                    })
                  }
                  maxDate={selectedDate?.end || undefined} 
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      size="small"
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "Start Date", 
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid container xs={12} sm={3} md={3}>
              <Typography sx={p_Properties} variant="p">
                End Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  // label="Select End Date"
                  value={selectedDate?.end}
                  onChange={(newValue) =>
                    setSelectedDate({
                      ...selectedDate,
                      end: dateFormatStartFun(newValue),
                    })
                  }
                  minDate={selectedDate?.start || undefined}
                  renderInput={(params) => (
                    <TextField 
                    fullWidth size="small"
                     {...params} 
                     inputProps={{
                        ...params.inputProps,
                        placeholder: "Start Date", // force it inside inputProps
                      }}
                     />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </form>
      </Card>
    </>
  );
};

export default DashboardFilter;
